<rwidget-ui-inline-alert [target]="target" [assetsPath]="assetsPath"></rwidget-ui-inline-alert>
<rwidget-ui-modal-alert [target]="target"></rwidget-ui-modal-alert>
